
import { Component, Vue } from "vue-property-decorator";
import { Action, Getter } from 'vuex-class'
import { isAgreeConfirm } from "@/utils/h5ToApp";

@Component
export class MessageProtectPopup extends Vue {
  @Action setIsAgreeMessageProtect

  show = false

  showPopup () {
    this.show = true
  }

  toPath (path: string) {
    this.$router.push(path)
  }

  // 是否同意 type '0'不同意 '1'同意
  isAgree (type: string) {
    if (type == '0') {
      // 调用原生方法，0退出APP
      isAgreeConfirm({ type })
      this.setIsAgreeMessageProtect(false)
    } else {
      const isAndroid = navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1
      // 调用原生方法，1关闭旧版App弹窗（仅安卓需要）
      isAndroid && isAgreeConfirm({ type })
      this.setIsAgreeMessageProtect(true)
      this.show = false
    }
  }
}
export default MessageProtectPopup
